/**
  DECKO Australia Custom Interactive JS Script
  Handles calculations, interlocking grid maps, portfolio togglers, 
  spec details, and direct Shopify AJAX Cart additions.
*/

(function () {
  // 1. Core Fallback Data (WPC, PPLite, Accessories) to guarantee out-of-the-box operation
  const FALLBACK_PRODUCTS = [
    {
      id: "demo-wpc-teak",
      shopify_product_id: 111,
      name: "Premium Teak WPC Tile",
      type: "wpc",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuDWvg6qAr2PwuywTMBRqwEeS2vDpgK-nf1EYKj72hcvsqqUosC9YuGXYd5X0_pVqhV2eeIu6mowWOyuhYEClGq2MPfkBE0dRdZG95E_b_OuBMMMyK-kplyj9bld2s05MeNlfNU65KlOvIu1tXpuTaoboo9Z91R6c1JAYrg1k148ZKi1TAv4YAzebvhsbDu45gdaQ7VcqJpQat9-UKDgK_82hHfYtDK5IidoyG0OxZU_h2uqxCjUbOMMMLO1KD-AQntMBOqXXbhdc6c",
      price: 13.49,
      spec: "300x300mm Deck Tile",
      material: "Wood Plastic Composite",
      dimensions: "300mm x 300mm x 22mm",
      weightText: "1.2 kg per tile",
      details: "Engineered with premium, long-lasting wood fibers combined with UV-stabilized recycled polymers. Has a rich teak appearance and deep, satisfying wood traction.",
      rating: 4.9,
      reviewsCount: 142,
      colorHex: "#b47b44",
      colorName: "Teak Gold"
    },
    {
      id: "demo-wpc-charcoal",
      shopify_product_id: 222,
      name: "Modern Charcoal WPC Tile",
      type: "wpc",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuCQ7FiCHJKMD-6Ex88PjEGf67cFptpGgimHuDA-Mt6rhPR33u5cPbFUn1IZr-SpdjD_579GRMiA0KzmYCod8DTBdNspZlB5vf7NkuVZPIWGeq-QL9znIb-905sn-xiHd2CHzlwFom-Bth0u9jxRcfcrivckKbhR17slcsthlWto7eqMY21ATnVhwlYHjQQjpG2-s7uJaY1jHfeGReGFW-oOZS_VfNKbXZcnQV7i6OSPAmWr-Jjo7Iqks0am7r_2ge9tfBQW6BDtzp4",
      price: 13.49,
      spec: "300x300mm Deck Tile",
      material: "Wood Plastic Composite",
      dimensions: "300mm x 300mm x 22mm",
      weightText: "1.2 kg per tile",
      details: "Sleek, modern deep anthracite finish that anchors any high-contrast contemporary patio. Anti-slip grooved texture that handles moisture excellently.",
      rating: 4.8,
      reviewsCount: 96,
      colorHex: "#2b2c2d",
      colorName: "Charcoal Black"
    },
    {
      id: "demo-wpc-brown",
      shopify_product_id: 333,
      name: "Classic Brown WPC Tile",
      type: "wpc",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuAWYmklWDfTv0iu6Fe0P0QvtL2Ibewwol7ZtjMXQQsbwex3Jd4Pb4FNLcEW2QcPiIM9DX-hC0kVsx_H-yr6Pn-JiEerXtUAIxvRGyveV_CDCCtcSBJaIKxibejYEzzNvbya2s233OZocSHKTqV5U6f0Ymnl-ouo9gTOvUpqHasDxhj_XhOC7p4nwFlJm5WPVhhnYvZKFz90OxGSmJp4Y2CGQ1gBaFBmp6eKUp1FUBwxrBMEXWJp_j8y4X490zXwEYN1HLKnQNlQMRQ",
      price: 13.49,
      spec: "300x300mm Deck Tile",
      material: "Wood Plastic Composite",
      dimensions: "300mm x 300mm x 22mm",
      weightText: "1.2 kg per tile",
      details: "Traditional, warm forest-mahogany dark brown. Blends beautifully with rich green backyards and garden planter boxes.",
      rating: 4.7,
      reviewsCount: 88,
      colorHex: "#5c4033",
      colorName: "Classic Brown"
    },
    {
      id: "demo-wpc-grey",
      shopify_product_id: 444,
      name: "Contemporary Grey WPC Tile",
      type: "wpc",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuBAPz2OhdvkweXXJC_na6fW9VuNbboJCfO2eAjh-shVintqpxdFgqGEWPV5Jp-j4jieuxBA5rQDVYN0egT6Nf7Hvsu9wOM1NzNFonNGpmCjuDAavIk-WLiNOQNh-5MfMUNyQLI4HURRS59Ayx8T3ICjOiEI3nqZWe5Z0Ssr2ii3Nsv8D98t87uww_lcrM7ywCDKrkLS7Qysb4jYehQAWjDqIMYQqrJ0e1ztmvGYJArklROxGgc_nzq8Pn-QJExwKSAcZqmuDd7iFFM",
      price: 13.49,
      spec: "300x300mm Deck Tile",
      material: "Wood Plastic Composite",
      dimensions: "300mm x 300mm x 22mm",
      weightText: "1.2 kg per tile",
      details: "Incredibly architectural mist grey with silver hues. Beautifully mimics salt-kissed coastal wood. Perfect for modern poolsides, balconies, and coastal residential settings.",
      rating: 4.8,
      reviewsCount: 110,
      colorHex: "#8e9092",
      colorName: "Slate Grey"
    },
    {
      id: "demo-pp-teak",
      shopify_product_id: 555,
      name: "Lite Teak Polymer Tile",
      type: "pplite",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuDt6dasu-Hoj5cvcR9gtBBzrlOydCLnHVBlj7RKeCQZV-0D26yKhgUxvoVxNopEt04osCvpjnfurf9AWNyNf6SS60FrOE6lH8CkUpJm6JgMz_ePa2ekUcKCJoFZViWlr05GaBkeuyD0TFtYDAw1j3_aq-BLDT4HBjld1c8RARQQdD5gYR139HDGbnq7ddBYRH8XExT5dyU4859qwwp6QyjGoOdWbPxJKRBcXCm77IOz4vFlLslhpGC_GwPZewiadlV9WW96orLpS70",
      price: 8.95,
      spec: "300x300mm PP Ventilation Tile",
      material: "High-Impact Polypropylene",
      dimensions: "300mm x 300mm x 15mm",
      weightText: "0.45 kg per tile",
      details: "Super lightweight, easy-to-pack polypropylene compilation tile. Ideal for balcony renters, temporary exhibition pavilions, or caravan structures.",
      rating: 4.6,
      reviewsCount: 75,
      colorHex: "#b28d6c",
      colorName: "Lite Teak"
    },
    {
      id: "demo-pp-charcoal",
      shopify_product_id: 666,
      name: "Lite Charcoal Polymer Tile",
      type: "pplite",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuCCICm1bBD30ArVa5ikeABdIO6wZxyQs-zhV6jZAc_GRe04Ez-eqi6speqE0fmcFPKNUvFP1Keasgla88gT3LvBcw28yh8r4hBlnBaRuANoLzD2R93Dl1FejfMNx757l9FlkCpjg5bli1va40NJv22BMPydJdWjLBRniwWemRNH5xOsjpDgq5kboTF-L2NUvYM2scJwnxcqFZSE2YOjPWQtKn57SWtDLYHruCdTA2THjEtbxjc4U0yTe7s2ENys_BiLlnsHC2aGBDE",
      price: 8.95,
      spec: "300x300mm PP Ventilation Tile",
      material: "High-Impact Polypropylene",
      dimensions: "300mm x 300mm x 15mm",
      weightText: "0.45 kg per tile",
      details: "Charcoal polypropylene tile with modular rain drainage grid. Resistant to car oil, acid spills, and standard patio cleaning formulas.",
      rating: 4.5,
      reviewsCount: 62,
      colorHex: "#383a3d",
      colorName: "Lite Charcoal"
    },
    {
      id: "demo-pp-brown",
      shopify_product_id: 777,
      name: "Lite Brown Polymer Tile",
      type: "pplite",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuCWs_D11TlReCWmqUSNGrLwWrsrkFG6wuFp1wCZ47WVUgr4cTWZ2qdNuf3bsvdAX7EiBmVFj7CagaBUzFR_vOIzLDWiwccsBWAzVrriix5Kcs48bXxIp63q3Ht4EZTHGEDEv55HInBeo__cORksyR69gy_le4wQH8PyIUYsgsKTqCDTBbkMlsd8CrlC3fZFzag8XDMq0syEO9diHpfTD-YAzscukruEplM96pO2KyJ2_ejSN9CSLSq-1ClFzRkAYVS3ZjTjd1afK2g",
      price: 8.95,
      spec: "300x300mm PP Ventilation Tile",
      material: "High-Impact Polypropylene",
      dimensions: "300mm x 300mm x 15mm",
      weightText: "0.45 kg per tile",
      details: "Lightweight brown composite texture. Integrates nicely on cold grey concrete apartment balconies to add immediate natural warmth without violating tenancy rules.",
      rating: 4.4,
      reviewsCount: 51,
      colorHex: "#6d5a49",
      colorName: "Lite Earthy Brown"
    },
    {
      id: "demo-pp-grey",
      shopify_product_id: 888,
      name: "Lite Grey Polymer Tile",
      type: "pplite",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuARcbnNmM7T09Ck72wNYRR4TyFsNw6-Af5PRwi8-clBK8a5jjQ0ZbkHXtHnkFWMnzFaEy7Ix1MdD7g0XIxGi8PlYDCDIimUy1-szA0_LE4-_xC5iOASUd_PCsxJwUU3LIbC8PEQPdQT6WfViVjNdXVo4UZSF7Qhmj_WQm4UkqB5ZOZRDHCJZWh0a6YLnmZ0IruS1wrfxVfTrcWdLTNigdQHk3v8L1Q57lY9L9mTuXYwMln4bVkp4iwENeizYgn7HkleqP01TIiNNM4",
      price: 8.95,
      spec: "300x300mm PP Ventilation Tile",
      material: "High-Impact Polypropylene",
      dimensions: "300mm x 300mm x 15mm",
      weightText: "0.45 kg per tile",
      details: "Modern neutral grey high-density polyolefin tile. Resistant to extreme heat expansion and provides safe walking surfaces during rain.",
      rating: 4.6,
      reviewsCount: 82,
      colorHex: "#a0a2a4",
      colorName: "Lite Pebble Grey"
    },
    {
      id: "demo-edge-teak",
      shopify_product_id: 999,
      name: "WPC Bevel Trim (Teak)",
      type: "accessory",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuDWvg6qAr2PwuywTMBRqwEeS2vDpgK-nf1EYKj72hcvsqqUosC9YuGXYd5X0_pVqhV2eeIu6mowWOyuhYEClGq2MPfkBE0dRdZG95E_b_OuBMMMyK-kplyj9bld2s05MeNlfNU65KlOvIu1tXpuTaoboo9Z91R6c1JAYrg1k148ZKi1TAv4YAzebvhsbDu45gdaQ7VcqJpQat9-UKDgK_82hHfYtDK5IidoyG0OxZU_h2uqxCjUbOMMMLO1KD-AQntMBOqXXbhdc6c",
      price: 6.50,
      spec: "300mm Border Boundary Edge",
      material: "Wood Plastic Composite",
      dimensions: "300mm x 70mm x 22mm",
      weightText: "0.3kg per border",
      details: "Matches perfectly with your WPC Premium Teak Tiles. Provides a elegant bevelled wheelchair and cart friendly ramp border to clean up your deck layout and prevent trippings.",
      rating: 4.8,
      reviewsCount: 41,
      colorHex: "#b47b44",
      colorName: "Teak Gold"
    },
    {
      id: "demo-edge-charcoal",
      shopify_product_id: 1010,
      name: "WPC Bevel Trim (Charcoal)",
      type: "accessory",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuCQ7FiCHJKMD-6Ex88PjEGf67cFptpGgimHuDA-Mt6rhPR33u5cPbFUn1IZr-SpdjD_579GRMiA0KzmYCod8DTBdNspZlB5vf7NkuVZPIWGeq-QL9znIb-905sn-xiHd2CHzlwFom-Bth0u9jxRcfcrivckKbhR17slcsthlWto7eqMY21ATnVhwlYHjQQjpG2-s7uJaY1jHfeGReGFW-oOZS_VfNKbXZcnQV7i6OSPAmWr-Jjo7Iqks0am7r_2ge9tfBQW6BDtzp4",
      price: 6.50,
      spec: "300mm Border Boundary Edge",
      material: "Wood Plastic Composite",
      dimensions: "300mm x 70mm x 22mm",
      weightText: "0.3kg per border",
      details: "Bevelled transition edge border for Charcoal WPC Tiles. Creates a beautifully polished, clean boundary line which locks into the male/female tabs flawlessly.",
      rating: 4.9,
      reviewsCount: 30,
      colorHex: "#2b2c2d",
      colorName: "Charcoal Black"
    },
    {
      id: "demo-underlay",
      shopify_product_id: 1111,
      name: "Noise-Reducing Weed Underlay",
      type: "accessory",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuDt6dasu-Hoj5cvcR9gtBBzrlOydCLnHVBlj7RKeCQZV-0D26yKhgUxvoVxNopEt04osCvpjnfurf9AWNyNf6SS60FrOE6lH8CkUpJm6JgMz_ePa2ekUcKCJoFZViWlr05GaBkeuyD0TFtYDAw1j3_aq-BLDT4HBjld1c8RARQQdD5gYR139HDGbnq7ddBYRH8XExT5dyU4859qwwp6QyjGoOdWbPxJKRBcXCm77IOz4vFlLslhpGC_GwPZewiadlV9WW96orLpS70",
      price: 24.95,
      spec: "10m x 1m Ground Protective Roll",
      material: "Geo-synthetic Polyethylene Grid",
      dimensions: "10m x 1m Grid",
      weightText: "1.5kg roll",
      details: "Essential underlay if laying deck tiles over grass, soil, or cracking stone. Keeps weed shoots from poking through decking seams, softens the acoustic profile when walked on, and aids ventilation.",
      rating: 4.7,
      reviewsCount: 52,
      colorHex: "#1a1a1a",
      colorName: "Solid Black"
    }
  ];

  const FALLBACK_FAQS = [
    {
      question: "How do the interlocking peg-and-loop tiles snap together?",
      answer: "Each tile contains interlocking loop edges on two adjacent sides and matching peg tags on the other sides. Place your first tile in a corner, orient its tags, place the adjacent tile down directly overlapping the loops, and apply firm foot pressure. No adhesive or screws needed!",
      category: "Installation"
    },
    {
      question: "Are DECKO tiles rental-friendly? Can I lay them on old concrete?",
      answer: "Yes, 100%! Since we use a floating interlocking structure, the tiles nestle directly on raw concrete or old ceramic tiling. When you prepare to relocate, simply click them apart, stack them in portable boxes, and transport them to your next location without any lease violations.",
      category: "Renters & Durability"
    },
    {
      question: "What is the structural difference between WPC and PP Lite?",
      answer: "Premium WPC is constructed with real wood grain composite material, presenting a heavier tactile weight and genuine forest timber look. PP Lite is a high-grade lightweight recyclable plastic matrix, perfect for easy packing, fast cleaning drainages, and budget-friendly installations.",
      category: "Materials"
    }
  ];

  const FALLBACK_PORTFOLIO = [
    {
      id: "project-1",
      title: "Harbour Apartment Balcony Renovation",
      location: "Sydney Metro, NSW",
      tileType: "Premium Teak WPC",
      areaSqM: 6.8,
      tilesUsed: 78,
      timeTaken: "2 Hours",
      description: "Home renovator Garry Jenkins wanted to transform his cracked, weathering concrete balcony into an elegant outdoor lounge. Garry laid Teak WPC tiles directly over concrete without screws, finishing the frame perimeters with bevel edges.",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuA_jt-_ijRKvDIe2kfMQklvlDy0PXa_KZCi0sxEKkQI8cJO2a3dgCOPhxHbsVkjMZy6Qu467D6qPW11705ZsoLLI04hOFBV-fXI89tII0IOLmQgtvif_C0Z-raArR2aRQu3sBcHySjjCKrzNWIpGW27OyaoZxah43CNed00IDIzjpbaLO-6gKRmLRc7QxQRfnw-XqveytGvlcyJPqGasF4wZLVs8q2y1Sp2qyHEoO7d2EquurkH88u-e37IAAT6FSwUy42dS4dtCUw"
    },
    {
      id: "project-2",
      title: "Cozy Garden Sun-deck Layout",
      location: "St Kilda, VIC",
      tileType: "Contemporary Grey WPC",
      areaSqM: 10.5,
      tilesUsed: 120,
      timeTaken: "3.5 Hours",
      description: "Amateur builder Monica secured this outdoor deck perimeter over an existing underlay mat. The Contemporary Grey composite layout completely blocks weed growth while resisting UV fade under the Victorian sun.",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuCQ7FiCHJKMD-6Ex88PjEGf67cFptpGgimHuDA-Mt6rhPR33u5cPbFUn1IZr-SpdjD_579GRMiA0KzmYCod8DTBdNspZlB5vf7NkuVZPIWGeq-QL9znIb-905sn-xiHd2CHzlwFom-Bth0u9jxRcfcrivckKbhR17slcsthlWto7eqMY21ATnVhwlYHjQQjpG2-s7uJaY1jHfeGReGFW-oOZS_VfNKbXZcnQV7i6OSPAmWr-Jjo7Iqks0am7r_2ge9tfBQW6BDtzp4"
    }
  ];

  // 2. State & Settings
  let products = [];
  let currentCategory = "all";
  let searchQuery = "";

  // Calculator values
  let calcSqm = 20;
  let calcWastePct = 10;
  let selectedCalcIds = [];

  // Modal selector item
  let activeDetailProduct = null;
  let modalQtyCount = 1;

  // Initialize application
  document.addEventListener("DOMContentLoaded", function () {
    initProductsData();
    initPromoTickerRotation();
    initCalculatorControls();
    initCategoryTabs();
    initSearchBox();
    initPortfolioBento();
    initFAQAccordions();
    initModalsPopup();
    initSampleFormSubmit();
    initCartDrawerUI();

    // Render original items grid
    renderProductsGrid();
    renderCalculatorChoices();
    updateCalculatorMath();
  });

  // --------------------------------------------------------------------------
  // Promo Ticker — rotates between configured messages (matches React PromoBanner)
  // --------------------------------------------------------------------------
  function initPromoTickerRotation() {
    const rotator = document.querySelector("[data-decko-ticker-rotator]");
    if (!rotator) return;
    const msgs = rotator.querySelectorAll("[data-decko-ticker-msg]");
    if (msgs.length < 2) return;
    const intervalMs = parseInt(rotator.getAttribute("data-interval"), 10) || 4500;
    let i = 0;
    setInterval(function () {
      msgs[i].classList.remove("is-active");
      i = (i + 1) % msgs.length;
      msgs[i].classList.add("is-active");
    }, intervalMs);
  }

  // Load and marry Shopify arrays with fallback indices
  function initProductsData() {
    if (window.DECKO_SHOPIFY_PRODUCTS && window.DECKO_SHOPIFY_PRODUCTS.length > 0) {
      products = window.DECKO_SHOPIFY_PRODUCTS;
    } else {
      products = FALLBACK_PRODUCTS;
    }

    // Default selection: first WPC and first PP Lite, for an instant comparison
    const firstWpc = products.find(p => p.type === 'wpc');
    const firstPp = products.find(p => p.type === 'pplite');
    selectedCalcIds = [];
    if (firstPp) selectedCalcIds.push(String(firstPp.id));
    if (firstWpc) selectedCalcIds.push(String(firstWpc.id));
  }

  // --------------------------------------------------------------------------
  // 3. Category & Search UI Rendering Flow
  // --------------------------------------------------------------------------
  function initCategoryTabs() {
    const tabs = document.querySelectorAll(".decko-tab-btn");
    tabs.forEach(tab => {
      tab.addEventListener("click", function () {
        tabs.forEach(t => t.classList.remove("active"));
        this.classList.add("active");
        currentCategory = this.getAttribute("data-category");
        renderProductsGrid();
      });
    });
  }

  function initSearchBox() {
    const searchField = document.getElementById("decko-catalog-search");
    if (searchField) {
      searchField.addEventListener("input", function (e) {
        searchQuery = e.target.value.toLowerCase().trim();
        renderProductsGrid();
      });
    }
  }

  function renderProductsGrid() {
    // filter products
    const filtered = products.filter(p => {
      const matchesSearch = p.name.toLowerCase().includes(searchQuery) ||
        p.material.toLowerCase().includes(searchQuery) ||
        p.colorName.toLowerCase().includes(searchQuery);

      if (currentCategory === "all") return matchesSearch;
      return p.type === currentCategory && matchesSearch;
    });

    // Divide segment sections
    const wpcList = filtered.filter(p => p.type === "wpc");
    const ppList = filtered.filter(p => p.type === "pplite");
    const accList = filtered.filter(p => p.type === "accessory");

    // Display counts
    const countWpcEl = document.getElementById("count-wpc");
    const countPpEl = document.getElementById("count-pplite");
    const countAccEl = document.getElementById("count-accessory");

    if (countWpcEl) countWpcEl.textContent = `${wpcList.length} styles available`;
    if (countPpEl) countPpEl.textContent = `${ppList.length} styles available`;
    if (countAccEl) countAccEl.textContent = `${accList.length} items available`;

    // Render individual columns
    renderBlockSection("grid-wpc", wpcList, "wpc");
    renderBlockSection("grid-pplite", ppList, "pplite");
    renderBlockSection("grid-accessory", accList, "accessory");

    // Toggle parent block layouts depending on filter active counts
    toggleSegmentVisibility("decko-segment-wpc", wpcList.length > 0);
    toggleSegmentVisibility("decko-segment-pplite", ppList.length > 0);
    toggleSegmentVisibility("decko-segment-accessory", accList.length > 0);
  }

  function toggleSegmentVisibility(id, condition) {
    const el = document.getElementById(id);
    if (!el) return;
    if (condition) {
      el.classList.remove("hidden");
    } else {
      el.classList.add("hidden");
    }
  }

  function renderBlockSection(targetId, itemsList, typeCode) {
    const container = document.getElementById(targetId);
    if (!container) return;

    if (itemsList.length === 0) {
      container.innerHTML = `
        <div style="grid-column: 1 / -1; text-align: center; padding: 30px; background-color: white; border: 1px dashed #c6c8b8; border-radius: 4px;">
          <p style="font-size: 11px; color:#7d806a; margin:0;">No materials match the filter criteria in this row.</p>
        </div>
      `;
      return;
    }

    container.innerHTML = itemsList.map(p => {
      const bestSellerBadge = p.isBestseller ? `<div class="decko-card-bestseller-badge">Bestseller</div>` : '';
      const categoryLabel = p.type === 'wpc' ? 'Premium WPC' : p.type === 'pplite' ? 'PP Lite' : 'Accessory';
      const coverageLabel = p.type === 'wpc' ? '$149.89/m²' : p.type === 'pplite' ? '$99.44/m²' : 'DIY Part';
      const starsHTML = generateStarRatingHTML(p.rating);

      return `
        <div class="decko-card" data-product-id="${p.id}">
          <div class="decko-card-visual" style="position: relative; width: 100%; aspect-ratio: 1/1; background-color: #dbdbdb; overflow: hidden;">
            ${bestSellerBadge}
            <img src="${p.image}" alt="${p.name}" loading="lazy" decoding="async" style="width: 100%; height: 100%; object-fit: cover; transition: transform 0.5s ease;" />

            <div class="decko-card-hover-overlay">
              <button onclick="event.stopPropagation(); window.DECKO_OPEN_DETAILS('${p.id}')" class="decko-card-hover-btn" title="Inspect Material Profiles">
                <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" style="width: 20px; height: 20px; display: inline-block;">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                  <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                </svg>
              </button>
            </div>

            <div class="decko-card-category-badge">${categoryLabel}</div>
          </div>
          <div class="decko-card-details" style="padding: 16px; display: flex; flex-direction: column; flex-grow: 1;">
            <div class="decko-card-rating-row" style="display: flex; align-items: center; gap: 6px; margin-bottom: 8px;">
              <div style="display: flex; gap: 2px; align-items: center;">${starsHTML}</div>
              <span class="decko-card-rating-count" style="font-size: 11px; font-weight: 600; color: var(--color-brand-text-muted);">(${p.reviewsCount})</span>
            </div>

            <!-- Price block — moved ABOVE title per brand spec -->
            <div class="decko-card-price-row" style="display: flex; justify-content: space-between; align-items: baseline; gap: 8px; margin-bottom: 6px;">
              <div>
                <strong class="decko-card-amount decko-headline" style="font-size: 22px; font-weight: 700; color: var(--color-brand-primary); line-height: 1;">$${Number(p.price).toFixed(2)}</strong>
                <span style="font-size: 10px; color: var(--color-brand-text-muted); font-weight: 600; margin-left: 2px;">AUD ea</span>
              </div>
              <span class="decko-card-coverage-label" style="font-size: 10px; color: var(--color-brand-primary); font-weight: 600; white-space: nowrap;">${coverageLabel}</span>
            </div>

            <a href="${p.url || '#'}" class="decko-card-title-link" style="text-decoration: none; color: inherit;"><h3 class="decko-card-title decko-headline" style="font-size: 17px; font-weight: 700; margin: 0 0 4px 0; text-transform: uppercase; line-height: 1.15; cursor: pointer;">${p.name}</h3></a>
            <p class="decko-card-spec-tag" style="margin: 0 0 12px 0; font-size: 12px; color: var(--color-brand-text-muted);">${p.spec}</p>

            <button onclick="event.stopPropagation(); window.DECKO_BUY_IMMEDIATE_CARD(this, '${p.id}')" class="decko-btn-add-full" style="margin-top: auto; width: 100%;">
              <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" style="width: 16px; height: 16px; display: inline-block; vertical-align: middle; margin-right: 6px;">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
              </svg>
              Add to Cart
            </button>
          </div>
        </div>
      `;
    }).join("");
  }


  // --------------------------------------------------------------------------
  // 4. Area Estimator Logic
  // --------------------------------------------------------------------------
  function initCalculatorControls() {
    const calcSection = document.getElementById("decko-calculator-section");
    const launchBtn1 = document.getElementById("decko-estimator-launch-bar");
    const launchBtn2 = document.getElementById("decko-estimator-launch");

    function toggleCalculator() {
      if (!calcSection) return;
      const isCollapsed = calcSection.classList.contains("decko-calculator-collapsed") || !calcSection.classList.contains("decko-calculator-expanded");
      if (isCollapsed) {
        calcSection.classList.remove("decko-calculator-collapsed");
        calcSection.classList.add("decko-calculator-expanded");
        if (launchBtn1) launchBtn1.textContent = "Hide Estimator";
        if (launchBtn2) launchBtn2.textContent = "Hide Estimator";
      } else {
        calcSection.classList.add("decko-calculator-collapsed");
        calcSection.classList.remove("decko-calculator-expanded");
        if (launchBtn1) launchBtn1.textContent = "Launch Estimator";
        if (launchBtn2) launchBtn2.textContent = "Launch Estimator";
      }
    }
    if (launchBtn1) launchBtn1.addEventListener("click", toggleCalculator);
    if (launchBtn2) launchBtn2.addEventListener("click", toggleCalculator);

    // Total SQM input
    const sqmInput = document.getElementById("decko-sqm-input");
    if (sqmInput) {
      sqmInput.value = calcSqm;
      sqmInput.addEventListener("input", function () {
        let v = parseFloat(this.value);
        if (isNaN(v) || v < 0) v = 0;
        calcSqm = v;
        updateCalculatorMath();
      });
    }

    // Quick SQM presets
    document.querySelectorAll(".decko-sqm-preset").forEach(function (btn) {
      btn.addEventListener("click", function () {
        const v = parseFloat(this.getAttribute("data-sqm"));
        if (!isNaN(v)) {
          calcSqm = v;
          if (sqmInput) sqmInput.value = v;
          updateCalculatorMath();
        }
      });
    });

    // Optional wastage allowance
    const wasteBtns = document.querySelectorAll(".decko-waste-btn");
    wasteBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        wasteBtns.forEach(function (b) { b.classList.remove("active"); });
        this.classList.add("active");
        calcWastePct = parseInt(this.getAttribute("data-waste"), 10) || 0;
        updateCalculatorMath();
      });
    });
  }

  // Items per square metre: manual tag override, else auto from mm dimensions
  function calcItemsPerSqm(p) {
    if (p && p.items_per_sqm && Number(p.items_per_sqm) > 0) {
      return Number(p.items_per_sqm);
    }
    const matches = String((p && p.dimensions) || "").match(/(\d+(?:\.\d+)?)\s*mm/gi);
    if (matches && matches.length >= 2) {
      const lengthMm = parseFloat(matches[0]);
      const widthMm = parseFloat(matches[1]);
      if (lengthMm > 0 && widthMm > 0) {
        return 1000000 / (lengthMm * widthMm);
      }
    }
    return 11.11; // safe fallback for 300x300mm tiles
  }

  function calcProductTotals(p) {
    const itemsPerSqm = calcItemsPerSqm(p);
    const wasteFactor = 1 + (calcWastePct / 100);
    const totalItems = Math.ceil(calcSqm * itemsPerSqm * wasteFactor);
    const totalCost = totalItems * Number(p.price || 0);
    return { itemsPerSqm: itemsPerSqm, totalItems: totalItems, totalCost: totalCost };
  }

  // Step 2: render the two catalog checklists (PP Lite + WPC)
  function renderCalculatorChoices() {
    const ppList = document.getElementById("decko-pick-pp-list");
    const wpcList = document.getElementById("decko-pick-wpc-list");

    const ppItems = products.filter(function (p) { return p.type === "pplite"; });
    const wpcItems = products.filter(function (p) { return p.type === "wpc"; });

    function renderList(container, items) {
      if (!container) return;
      if (items.length === 0) {
        container.innerHTML = `<p class="decko-compare-empty">No products in this range.</p>`;
        return;
      }
      container.innerHTML = items.map(function (p) {
        const checked = selectedCalcIds.indexOf(String(p.id)) !== -1;
        const typeLabel = p.type === "wpc" ? "WPC" : "PP LITE";
        return `
          <label class="decko-calc-pick ${checked ? "active" : ""}">
            <input type="checkbox" class="decko-calc-pick-cb" value="${p.id}" ${checked ? "checked" : ""} />
            <img class="decko-calc-pick-thumb" src="${p.image}" alt="${p.name}" loading="lazy" decoding="async" />
            <span class="decko-calc-pick-meta">
              <span class="decko-calc-pick-name">${p.name}</span>
              <span class="decko-calc-pick-sub"><span class="decko-calc-pick-badge">${typeLabel}</span> $${Number(p.price).toFixed(2)} ea</span>
            </span>
          </label>
        `;
      }).join("");
    }

    renderList(ppList, ppItems);
    renderList(wpcList, wpcItems);

    document.querySelectorAll("#decko-pick-pp-list .decko-calc-pick-cb, #decko-pick-wpc-list .decko-calc-pick-cb").forEach(function (cb) {
      cb.addEventListener("change", function () {
        const id = String(this.value);
        const idx = selectedCalcIds.indexOf(id);
        if (this.checked) {
          if (idx === -1) selectedCalcIds.push(id);
        } else if (idx !== -1) {
          selectedCalcIds.splice(idx, 1);
        }
        renderCalculatorChoices();
        updateCalculatorMath();
      });
    });
  }

  // Build a single comparison card
  function renderCompareCard(p) {
    const t = calcProductTotals(p);
    const typeLabel = p.type === "wpc" ? "WPC" : "PP LITE";
    const costStr = t.totalCost.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return `
      <div class="decko-compare-card">
        <div class="decko-compare-card-head">
          <img class="decko-compare-thumb" src="${p.image}" alt="${p.name}" loading="lazy" decoding="async" />
          <div>
            <span class="decko-compare-badge">${typeLabel}</span>
            <h5 class="decko-compare-name">${p.name}</h5>
          </div>
        </div>
        <ul class="decko-compare-rows">
          <li><span>Dimensions</span><strong>${p.dimensions || "n/a"}</strong></li>
          <li><span>Items per m\u00B2</span><strong>${t.itemsPerSqm.toFixed(1)}</strong></li>
          <li><span>Price per item</span><strong>$${Number(p.price).toFixed(2)}</strong></li>
          <li><span>Total items (${calcSqm} m\u00B2)</span><strong>${t.totalItems}</strong></li>
        </ul>
        <div class="decko-compare-total"><span>Total cost</span><strong>$${costStr}</strong></div>
        <button type="button" class="decko-compare-view" onclick="window.DECKO_OPEN_DETAILS('${p.id}')">View details</button>
        <button class="decko-btn-primary decko-compare-add" onclick="window.DECKO_CALC_ADD('${p.id}')">Add ${t.totalItems} to Cart</button>
      </div>
    `;
  }

  // Recompute + render the comparison results (all ticked products)
  function updateCalculatorMath() {
    const wasteEl = document.getElementById("decko-val-waste");
    if (wasteEl) wasteEl.textContent = "+" + calcWastePct + "%";

    const sqmEcho = document.getElementById("decko-calc-sqm-echo");
    if (sqmEcho) sqmEcho.textContent = calcSqm + " m\u00B2";

    const box = document.getElementById("decko-compare-results");
    if (!box) return;

    const chosen = products.filter(function (p) { return selectedCalcIds.indexOf(String(p.id)) !== -1; });

    if (chosen.length === 0) {
      box.innerHTML = `<p class="decko-compare-empty">Tick one or more products above to compare.</p>`;
      return;
    }

    box.innerHTML = chosen.map(renderCompareCard).join("");
  }

  window.DECKO_CALC_ADD = function (productId) {
    const p = products.find(function (x) { return String(x.id) === String(productId); });
    if (!p) return;
    const t = calcProductTotals(p);
    if (t.totalItems > 0) addProductVariantToShopifyCart(p.id, t.totalItems);
  };

  // --------------------------------------------------------------------------
  // 5. Portfolio Bento Showcase
  // --------------------------------------------------------------------------
  let portfolioList = [];
  let selectedProject = null;

  function initPortfolioBento() {
    if (window.DECKO_DYNAMIC_PORTFOLIO && window.DECKO_DYNAMIC_PORTFOLIO.length > 0) {
      portfolioList = window.DECKO_DYNAMIC_PORTFOLIO;
    } else {
      portfolioList = FALLBACK_PORTFOLIO;
    }

    selectedProject = portfolioList[0];
    renderPortfolioTriggers();
    renderActiveProjectStage();
  }

  function renderPortfolioTriggers() {
    const triggerBox = document.getElementById("decko-portfolio-triggers");
    if (!triggerBox) return;

    triggerBox.innerHTML = portfolioList.map(item => {
      const activeClass = selectedProject && selectedProject.id === item.id ? "active" : "";
      return `
        <div class="decko-portfolio-card ${activeClass}" onclick="window.DECKO_SELECT_PORTFOLIO('${item.id}')">
          <span class="decko-portfolio-meta">${item.location} • ${item.tileType}</span>
          <h4 class="decko-portfolio-lead">${item.title}</h4>
        </div>
      `;
    }).join("");
  }

  window.DECKO_SELECT_PORTFOLIO = function (id) {
    selectedProject = portfolioList.find(item => item.id === id);
    renderPortfolioTriggers();
    renderActiveProjectStage();
  };

  function renderActiveProjectStage() {
    const heroBox = document.getElementById("decko-portfolio-hero");
    if (!heroBox || !selectedProject) return;

    heroBox.innerHTML = `
      <div class="decko-stage-img-box animate-fade">
        <img src="${selectedProject.image}" alt="${selectedProject.title}" loading="lazy" decoding="async" />
        <span class="decko-stage-tag">${selectedProject.location}</span>
      </div>
      
      <div class="decko-stage-metrics">
        <div class="decko-stage-metric-chip">
          <span class="decko-stage-chip-label">Surface Area</span>
          <span class="decko-stage-chip-val">${selectedProject.areaSqM} m²</span>
        </div>
        <div class="decko-stage-metric-chip">
          <span class="decko-stage-chip-label">Tiles Connected</span>
          <span class="decko-stage-chip-val">${selectedProject.tilesUsed} Tiles</span>
        </div>
        <div class="decko-stage-metric-chip">
          <span class="decko-stage-chip-label">Material Model</span>
          <span class="decko-stage-chip-val" style="font-size:11px;">${selectedProject.tileType}</span>
        </div>
        <div class="decko-stage-metric-chip">
          <span class="decko-stage-chip-label">DIY Install Time</span>
          <span class="decko-stage-chip-val">${selectedProject.timeTaken}</span>
        </div>
      </div>

      <div class="decko-stage-content">
        <h3 class="decko-headline text-xl font-bold uppercase text-[#1b1c17] mb-2">${selectedProject.title}</h3>
        <p class="decko-stage-desc">${selectedProject.description}</p>
      </div>
    `;
  }

  // --------------------------------------------------------------------------
  // 6. Direct FAQs accordions logic
  // --------------------------------------------------------------------------
  let faqs = [];
  function initFAQAccordions() {
    if (window.DECKO_DYNAMIC_FAQS && window.DECKO_DYNAMIC_FAQS.length > 0) {
      faqs = window.DECKO_DYNAMIC_FAQS;
    } else {
      faqs = FALLBACK_FAQS;
    }

    const container = document.getElementById("decko-faq-accordions");
    if (!container) return;

    container.innerHTML = faqs.map((faq, i) => {
      return `
        <div class="decko-faq-card" id="faq-item-${i}">
          <button class="decko-faq-trigger" onclick="window.DECKO_TOGGLE_FAQ(${i})">
            <span>${faq.question}</span>
            <span class="decko-faq-arrow">▶</span>
          </button>
          <div class="decko-faq-panel">
            <div class="decko-faq-inner">
              <p style="margin:0;">${faq.answer}</p>
              <strong>Topic Tag: ${faq.category}</strong>
            </div>
          </div>
        </div>
      `;
    }).join("");
  }

  window.DECKO_TOGGLE_FAQ = function (index) {
    const target = document.getElementById(`faq-item-${index}`);
    if (!target) return;

    const isOpen = target.classList.contains("open");

    // Close other panels
    document.querySelectorAll(".decko-faq-card").forEach(card => {
      card.classList.remove("open");
    });

    if (!isOpen) {
      target.classList.add("open");
    }
  };


  // --------------------------------------------------------------------------
  // 7. Tactical Specs Popup Modal Box
  // --------------------------------------------------------------------------
  function initModalsPopup() {
    const overlay = document.getElementById("decko-modal-overlay");
    const closeBtn = document.getElementById("decko-modal-close-btn");

    if (closeBtn && overlay) {
      closeBtn.addEventListener("click", window.DECKO_CLOSE_MODAL);

      // Close overlay on background clicking
      overlay.addEventListener("click", function (e) {
        if (e.target === overlay) {
          window.DECKO_CLOSE_MODAL();
        }
      });
    }

    // Modal tabs
    const tabs = document.querySelectorAll(".decko-modal-tab-btn");
    tabs.forEach(tab => {
      tab.addEventListener("click", function () {
        tabs.forEach(t => t.classList.remove("active"));
        this.classList.add("active");

        const mode = this.getAttribute("data-tab");
        document.getElementById("decko-modal-tab-desc").classList.add("hidden");
        document.getElementById("decko-modal-tab-tech").classList.add("hidden");
        const revTab = document.getElementById("decko-modal-tab-reviews");
        if (revTab) revTab.classList.add("hidden");

        if (mode === "desc") {
          document.getElementById("decko-modal-tab-desc").classList.remove("hidden");
        } else if (mode === "tech") {
          document.getElementById("decko-modal-tab-tech").classList.remove("hidden");
        } else if (mode === "reviews") {
          if (revTab) revTab.classList.remove("hidden");
        }
      });
    });

    // Step counter increments inside details modal box
    const btnDec10 = document.getElementById("decko-modal-qty-dec-10");
    const btnDec = document.getElementById("decko-modal-qty-dec");
    const btnInc = document.getElementById("decko-modal-qty-inc");
    const btnInc10 = document.getElementById("decko-modal-qty-inc-10");
    const inputQty = document.getElementById("decko-modal-qty-input");

    if (inputQty) {
      inputQty.addEventListener("input", function () {
        modalQtyCount = parseInt(this.value) || 1;
        updateModalCheckoutLabels();
      });
    }

    if (btnDec10) {
      btnDec10.addEventListener("click", () => {
        modalQtyCount = Math.max(1, modalQtyCount - 10);
        if (inputQty) inputQty.value = modalQtyCount;
        updateModalCheckoutLabels();
      });
    }
    if (btnDec) {
      btnDec.addEventListener("click", () => {
        modalQtyCount = Math.max(1, modalQtyCount - 1);
        if (inputQty) inputQty.value = modalQtyCount;
        updateModalCheckoutLabels();
      });
    }
    if (btnInc) {
      btnInc.addEventListener("click", () => {
        modalQtyCount += 1;
        if (inputQty) inputQty.value = modalQtyCount;
        updateModalCheckoutLabels();
      });
    }
    if (btnInc10) {
      btnInc10.addEventListener("click", () => {
        modalQtyCount += 10;
        if (inputQty) inputQty.value = modalQtyCount;
        updateModalCheckoutLabels();
      });
    }

    // Modal main checkout action button — orange CTA, success flash, then close
    const modalAddBtn = document.getElementById("decko-modal-add-cart-btn");
    if (modalAddBtn) {
      modalAddBtn.addEventListener("click", function () {
        if (!activeDetailProduct) return;
        addProductVariantToShopifyCart(activeDetailProduct.id, modalQtyCount);

        const labelEl = document.getElementById("decko-modal-add-cart-label");
        const originalLabel = labelEl ? labelEl.textContent : "";
        modalAddBtn.classList.add("is-added");
        if (labelEl) labelEl.textContent = "Tiles Added Successfully!";

        setTimeout(function () {
          modalAddBtn.classList.remove("is-added");
          if (labelEl) labelEl.textContent = originalLabel;
          window.DECKO_CLOSE_MODAL();
        }, 1500);
      });
    }
  }

  function generateStarRatingHTML(score) {
    let starsHTML = '';
    const roundedScore = Math.floor(score);
    const hasHalf = (score - roundedScore) >= 0.4;
    for (let i = 1; i <= 5; i++) {
      if (i <= roundedScore) {
        starsHTML += `
          <svg class="decko-star-filled" viewBox="0 0 24 24" style="width: 14px; height: 14px; fill: #fdaa40; color: #fdaa40; display: inline-block; vertical-align: middle;">
            <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
          </svg>
        `;
      } else if (i === roundedScore + 1 && hasHalf) {
        starsHTML += `
          <span class="decko-star-half" style="position: relative; display: inline-block; width: 14px; height: 14px; vertical-align: middle;">
            <svg viewBox="0 0 24 24" style="color: #cbd5e1; width: 14px; height: 14px; fill: currentColor; display: block;">
              <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
            </svg>
            <svg class="decko-star-filled" viewBox="0 0 24 24" style="position: absolute; top: 0; left: 0; width: 14px; height: 14px; fill: #fdaa40; color: #fdaa40; clip-path: inset(0 50% 0 0); display: block;">
              <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
            </svg>
          </span>
        `;
      } else {
        starsHTML += `
          <svg viewBox="0 0 24 24" style="color: #cbd5e1; width: 14px; height: 14px; fill: currentColor; display: inline-block; vertical-align: middle;">
            <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
          </svg>
        `;
      }
    }
    return starsHTML;
  }

  // Scroll to catalog section, check matching category filter, and scroll smoothly
  window.DECKO_SCROLL_TO_CATALOG = function (filterTag) {
    const tabBtn = document.querySelector(`.decko-tab-btn[data-category="${filterTag}"]`);
    if (tabBtn) {
      tabBtn.click();
    }
    const element = document.getElementById('products-section');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Immediate checkout card action button state modifier
  window.DECKO_BUY_IMMEDIATE_CARD = function (btn, productId) {
    const item = products.find(p => String(p.id) === String(productId));
    if (!item) return;

    addProductVariantToShopifyCart(item.id, 1);

    // Toggle button state to mimic ProductCard.tsx
    btn.classList.add("added");
    btn.style.backgroundColor = "var(--color-brand-primary-light)";
    btn.innerHTML = `
      <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" style="width: 16px; height: 16px; display: inline-block; vertical-align: middle; margin-right: 6px;">
        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/>
      </svg>
      Added To Cart!
    `;

    setTimeout(() => {
      btn.classList.remove("added");
      btn.style.backgroundColor = "";
      btn.innerHTML = `
        <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" style="width: 16px; height: 16px; display: inline-block; vertical-align: middle; margin-right: 6px;">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
        </svg>
        Add to Cart
      `;
    }, 1500);
  };

  window.DECKO_OPEN_DETAILS = function (productId) {
    const item = products.find(p => String(p.id) === String(productId));
    if (!item) return;

    activeDetailProduct = item;
    modalQtyCount = 1; // reset default pack count

    const pQtyInput = document.getElementById("decko-modal-qty-input");
    if (pQtyInput) pQtyInput.value = modalQtyCount;

    // Reset active tab state
    const modalTabs = document.querySelectorAll(".decko-modal-tab-btn");
    modalTabs.forEach(t => t.classList.remove("active"));
    const descTabBtn = document.querySelector(".decko-modal-tab-btn[data-tab='desc']");
    if (descTabBtn) descTabBtn.classList.add("active");

    document.getElementById("decko-modal-tab-desc").classList.remove("hidden");
    document.getElementById("decko-modal-tab-tech").classList.add("hidden");
    const revTab = document.getElementById("decko-modal-tab-reviews");
    if (revTab) revTab.classList.add("hidden");

    // Bind item values to overlay window fields
    document.getElementById("decko-modal-img").src = item.image;

    // Eyebrow line driven by product type (matches React ProductDetailsModal.tsx)
    const eyebrowMap = {
      wpc: "Premium Wood Composite Series",
      pplite: "Polypropylene Lite Series",
      accessory: "Genuine Decking Parts"
    };
    document.getElementById("decko-modal-subtitle").textContent = eyebrowMap[item.type] || `${item.material} Series`;

    document.getElementById("decko-modal-title").textContent = item.name;
    document.getElementById("decko-modal-price").textContent = `$${Number(item.price).toFixed(2)}`;
    document.getElementById("decko-modal-description").textContent = item.details;

    // Bestseller pill — show only for products flagged as bestseller
    const bestPill = document.getElementById("decko-modal-bestseller-pill");
    if (bestPill) bestPill.classList.toggle("hidden", !item.isBestseller);

    // Square Metre Coverage row — hide for accessories (not measured per m²)
    const coverageRow = document.getElementById("decko-modal-coverage-row");
    if (coverageRow) coverageRow.classList.toggle("hidden", item.type === "accessory");

    document.getElementById("decko-modal-material").textContent = item.material;
    document.getElementById("decko-modal-dims").textContent = item.dimensions;
    document.getElementById("decko-modal-weight").textContent = item.weightText;

    // Reviews data for this modal (also drives the header rating + count)
    const modalReviews = [
      { author: "Lachlan M.", location: "Cronulla, NSW", rating: 5, date: "May 12, 2026", title: "Extremely easy balcony remodel", comment: "Laid down these tiles on my high-rise balcony facing the sea. The salt air and morning sun used to melt raw timber, but these WPC tiles have held up flawlessly. Snapped the whole balcony together during my lunch break. Highly recommend!" },
      { author: "Sarah J.", location: "Kilda, VIC", rating: 5, date: "April 29, 2026", title: "Renter friendly lifesaver!", comment: "I rented an apartment with ugly green-stained concrete in the courtyard. Put down 90 of these Lite Charcoal tiles. It completely changed the space, looks incredibly sophisticated. My landlord saw it and offered to buy them from me when I leave!" },
      { author: "Marcus T.", location: "Noosa, QLD", rating: 4, date: "April 03, 2026", title: "Stands up to harsh Queensland UV", comment: "Excellent product. Stays flat and interlocks tightly even under intense summer temperatures. Doesn't get too hot to walk on barefoot either compared to raw stone. Edges were easy to trim using my hand jigsaw." }
    ];
    const reviewCount = modalReviews.length;
    const reviewAvg = reviewCount ? Math.round((modalReviews.reduce(function (s, r) { return s + r.rating; }, 0) / reviewCount) * 10) / 10 : 0;

    // Stars & Reviews population
    const starsContainer = document.getElementById("decko-modal-stars-container");
    if (starsContainer) {
      starsContainer.innerHTML = generateStarRatingHTML(reviewAvg);
    }
    
    const summaryReviewsEl = document.getElementById("decko-modal-reviews-summary");
    if (summaryReviewsEl) {
      summaryReviewsEl.textContent = `${reviewAvg} Star Rating (${reviewCount} customer review${reviewCount === 1 ? '' : 's'})`;
    }

    const reviewsCountEl = document.getElementById("decko-modal-reviews-count");
    if (reviewsCountEl) {
      reviewsCountEl.textContent = reviewCount;
    }

    // Render review list
    const reviewsListContainer = document.getElementById("decko-modal-reviews-list-container");
    if (reviewsListContainer) {
      const mockReviews = modalReviews;

      reviewsListContainer.innerHTML = mockReviews.map(r => {
        let rStars = '';
        for (let i = 0; i < 5; i++) {
          rStars += `
            <svg viewBox="0 0 24 24" style="width: 12px; height: 12px; color: ${i < r.rating ? '#fdaa40' : '#cbd5e1'}; ${i < r.rating ? 'fill: #fdaa40;' : ''}">
              <path fill="currentColor" d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
            </svg>
          `;
        }

        return `
          <div style="border-bottom: 1px solid #c6c8b8; padding-bottom: 10px; margin-bottom: 10px;">
            <div style="display: flex; justify-content: space-between; font-size: 11px; font-weight: bold; color: #1b1c17;">
              <span>${r.author} <span style="font-weight: normal; color: #45483c;">(${r.location})</span></span>
              <span style="font-weight: normal; color: #45483c;">${r.date}</span>
            </div>
            <div style="display: flex; gap: 2px; margin: 4px 0;">
              ${rStars}
            </div>
            <span style="display: block; font-weight: bold; color: #1b1c17; font-size: 11.5px;">${r.title}</span>
            <p style="margin: 2px 0 0 0; color: #45483c; font-size: 11px; line-height: 1.4;">${r.comment}</p>
          </div>
        `;
      }).join('');
    }

    updateModalCheckoutLabels();

    // Show modal overlay — MUST remove .hidden first because that rule has
    // `display: none !important;` which would otherwise win over .active
    const overlay = document.getElementById("decko-modal-overlay");
    if (overlay) {
      overlay.classList.remove("hidden");
      // Defer .active by one frame so the CSS transition can play
      requestAnimationFrame(function () { overlay.classList.add("active"); });
    }
  };

  window.DECKO_CLOSE_MODAL = function () {
    const overlay = document.getElementById("decko-modal-overlay");
    if (overlay) {
      overlay.classList.remove("active");
      // Re-hide after the close transition finishes (matches 0.25s opacity transition)
      setTimeout(function () { overlay.classList.add("hidden"); }, 260);
    }
    activeDetailProduct = null;
  };

  function updateModalCheckoutLabels() {
    if (!activeDetailProduct) return;
    const TILE_AREA = 0.09; // m² — 300mm × 300mm tile (matches React)
    const subtotal = modalQtyCount * activeDetailProduct.price;
    const coverageSqm = (modalQtyCount * TILE_AREA).toFixed(1);
    const isAccessory = activeDetailProduct.type === "accessory";

    // Live Line Subtotal (right of qty stepper)
    const subtotalEl = document.getElementById("decko-modal-line-subtotal");
    if (subtotalEl) {
      subtotalEl.textContent = `$${subtotal.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }

    // Coverage caption ("Covering ~X.X m²") — hide for accessories
    const coverageEl = document.getElementById("decko-modal-line-coverage");
    if (coverageEl) {
      if (isAccessory) {
        coverageEl.classList.add("hidden");
      } else {
        coverageEl.classList.remove("hidden");
        coverageEl.textContent = `Covering ~${coverageSqm} m²`;
      }
    }

    // CTA label — "Add 10 Tiles to Cart" / "Add 4 Items to Cart" (accessory)
    const labelEl = document.getElementById("decko-modal-add-cart-label");
    if (labelEl) {
      const unit = isAccessory ? (modalQtyCount === 1 ? "Item" : "Items") : (modalQtyCount === 1 ? "Tile" : "Tiles");
      labelEl.textContent = `Add ${modalQtyCount} ${unit} to Cart`;
    }
  }


  // --------------------------------------------------------------------------
  // 8. Swatches samples requests form submissions
  // --------------------------------------------------------------------------
  function initSampleFormSubmit() {
    const form = document.getElementById("decko-sample-form");
    const container = document.getElementById("decko-sample-success");

    if (form && container) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();

        const palette = document.getElementById("decko-sample-palette-option").value;
        const address = document.getElementById("decko-sample-address").value;
        const descEl = document.getElementById("decko-sample-recipient-desc");

        if (descEl) {
          descEl.textContent = palette;
        }

        form.classList.add("hidden");
        container.classList.remove("hidden");
      });
    }
  }



  // --------------------------------------------------------------------------
  // 9. Cart Drawer wired to the REAL Shopify cart (production)
  //    Source of truth: Shopify cart. We add, change, and remove against
  //    Shopify, then render the drawer from the real cart response.
  //    Checkout sends the customer to Shopify's real /checkout.
  // --------------------------------------------------------------------------

  // Display-only free-shipping threshold (in dollars). This must match a real
  // Shopify shipping rule, otherwise it is just a marketing visual.
  var DECKO_FREE_SHIP_THRESHOLD = 600;

  function deckoShopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root
      : '/';
  }

  function deckoMoney(cents) {
    return '$' + (Number(cents) / 100).toLocaleString('en-AU', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function initCartDrawerUI() {
    var overlay = document.getElementById("decko-cart-overlay");
    var closeBtn = document.getElementById("decko-cart-close-btn");
    var floatToggle = document.getElementById("decko-floating-cart-toggle");
    var browseBtn = document.getElementById("decko-cart-browse-btn");
    var checkoutTrigger = document.getElementById("decko-cart-checkout-trigger");

    // The simulated multi-step flow is retired. Keep only the items panel.
    var stepIndicators = document.querySelector(".decko-cart-steps");
    if (stepIndicators) stepIndicators.classList.add("hidden");
    var stepShipping = document.getElementById("decko-cart-step-shipping");
    if (stepShipping) stepShipping.classList.add("hidden");
    var stepSuccess = document.getElementById("decko-cart-step-success");
    if (stepSuccess) stepSuccess.classList.add("hidden");
    var stepList = document.getElementById("decko-cart-step-list");
    if (stepList) stepList.classList.remove("hidden");

    if (floatToggle) {
      floatToggle.addEventListener("click", function () {
        openCartDrawer();
        refreshCart();
      });
    }
    if (closeBtn) closeBtn.addEventListener("click", closeCartDrawer);
    if (overlay) {
      overlay.addEventListener("click", function (e) {
        if (e.target === overlay) closeCartDrawer();
      });
    }
    if (browseBtn) browseBtn.addEventListener("click", closeCartDrawer);

    // Checkout goes to Shopify's real, secure checkout.
    if (checkoutTrigger) {
      checkoutTrigger.addEventListener("click", function () {
        window.location.href = deckoShopRoot() + 'checkout';
      });
    }

    // Sync the badge and drawer with whatever is already in the cart on load.
    refreshCart();
  }

  function closeCartDrawer() {
    var overlay = document.getElementById("decko-cart-overlay");
    if (overlay) overlay.classList.remove("active");
  }

  function openCartDrawer() {
    var overlay = document.getElementById("decko-cart-overlay");
    if (overlay) overlay.classList.add("active");
  }

  // Pull the real Shopify cart and repaint the drawer from it.
  function refreshCart() {
    return fetch(deckoShopRoot() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function (err) { console.error('DECKO cart read failed:', err); });
  }

  function renderCart(cart) {
    var itemsContainer = document.getElementById("decko-cart-items-container");
    var emptyView = document.getElementById("decko-cart-empty-view");
    var summaryBox = document.getElementById("decko-cart-summary-box");
    var footerActions = document.getElementById("decko-cart-footer-actions");
    var badgeCounter = document.getElementById("decko-floating-cart-counter-badge");
    var shippingProgress = document.getElementById("decko-cart-shipping-progress");

    var itemCount = cart && cart.item_count ? cart.item_count : 0;

    if (badgeCounter) {
      badgeCounter.textContent = itemCount;
      badgeCounter.style.display = itemCount > 0 ? "flex" : "none";
    }

    if (!cart || itemCount === 0) {
      if (emptyView) emptyView.classList.remove("hidden");
      if (summaryBox) summaryBox.classList.add("hidden");
      if (footerActions) footerActions.classList.add("hidden");
      if (shippingProgress) shippingProgress.classList.add("hidden");
      if (itemsContainer) itemsContainer.innerHTML = "";
      return;
    }

    if (emptyView) emptyView.classList.add("hidden");
    if (summaryBox) summaryBox.classList.remove("hidden");
    if (footerActions) footerActions.classList.remove("hidden");

    if (itemsContainer) {
      itemsContainer.innerHTML = cart.items.map(function (item) {
        var subtitle = item.variant_title || item.product_type || item.product_title || "";
        var imgSrc = item.image ? item.image.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_120x$1$2') : "";
        return ''
          + '<div class="decko-cart-item">'
          + '  <img src="' + imgSrc + '" class="decko-cart-item-img" alt="' + (item.product_title || '') + '" loading="lazy" decoding="async" />'
          + '  <div class="decko-cart-item-details">'
          + '    <h4>' + (item.product_title || item.title) + '</h4>'
          + '    <p>' + subtitle + '</p>'
          + '    <div class="decko-cart-item-actions">'
          + '      <button class="decko-cart-qty-btn" onclick="window.DECKO_UPDATE_CART_QTY(\'' + item.key + '\', -1)">-</button>'
          + '      <span class="decko-cart-qty-val">' + item.quantity + '</span>'
          + '      <button class="decko-cart-qty-btn" onclick="window.DECKO_UPDATE_CART_QTY(\'' + item.key + '\', 1)">+</button>'
          + '    </div>'
          + '  </div>'
          + '  <div class="decko-cart-item-price">'
          + '    <span class="decko-cart-item-total">' + deckoMoney(item.final_line_price) + '</span>'
          + '    <button class="decko-cart-remove-btn" onclick="window.DECKO_REMOVE_FROM_CART(\'' + item.key + '\')">Remove</button>'
          + '  </div>'
          + '</div>';
      }).join("");
    }

    var subtotalEl = document.getElementById("decko-cart-subtotal");
    var discountRow = document.getElementById("decko-cart-discount");
    var shippingEl = document.getElementById("decko-cart-shipping");
    var grandEl = document.getElementById("decko-cart-grand-total");
    var weightEl = document.getElementById("decko-cart-weight");
    var checkoutTotalEl = document.getElementById("decko-checkout-summary-total");

    if (subtotalEl) subtotalEl.textContent = deckoMoney(cart.items_subtotal_price);

    // Real Shopify discount only. Hide the row when there is none.
    if (discountRow) {
      var discountRowWrap = discountRow.closest(".decko-cart-summary-row");
      if (cart.total_discount && cart.total_discount > 0) {
        discountRow.textContent = "-" + deckoMoney(cart.total_discount);
        if (discountRowWrap) discountRowWrap.classList.remove("hidden");
      } else if (discountRowWrap) {
        discountRowWrap.classList.add("hidden");
      }
    }

    if (shippingEl) shippingEl.textContent = "At checkout";
    if (grandEl) grandEl.textContent = deckoMoney(cart.total_price);
    if (checkoutTotalEl) checkoutTotalEl.textContent = deckoMoney(cart.total_price);
    if (weightEl) weightEl.textContent = (cart.total_weight / 1000).toFixed(1) + " kg";

    if (shippingProgress) {
      shippingProgress.classList.remove("hidden");
      var status = document.getElementById("decko-shipping-progress-status");
      var fill = document.getElementById("decko-shipping-progress-fill");
      var subtotalDollars = cart.items_subtotal_price / 100;
      if (subtotalDollars >= DECKO_FREE_SHIP_THRESHOLD) {
        if (status) status.innerHTML = "You have unlocked <strong>FREE METRO FREIGHT</strong>!";
        if (fill) fill.style.width = "100%";
      } else {
        var remaining = DECKO_FREE_SHIP_THRESHOLD - subtotalDollars;
        if (status) status.innerHTML = "Add <strong>$" + remaining.toFixed(2) + "</strong> more to unlock <strong>FREE METRO FREIGHT</strong>!";
        if (fill) fill.style.width = ((subtotalDollars / DECKO_FREE_SHIP_THRESHOLD) * 100) + "%";
      }
    }
  }

  // Quantity stepper inside the drawer, against the real cart line.
  window.DECKO_UPDATE_CART_QTY = function (lineKey, direction) {
    fetch(deckoShopRoot() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = cart.items.find(function (i) { return i.key === lineKey; });
        if (!line) return;
        var newQty = line.quantity + direction;
        if (newQty < 0) newQty = 0;
        return changeCartLine(lineKey, newQty);
      });
  };

  window.DECKO_REMOVE_FROM_CART = function (lineKey) {
    changeCartLine(lineKey, 0);
  };

  function changeCartLine(lineKey, quantity) {
    return fetch(deckoShopRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function (err) { console.error('DECKO cart change failed:', err); });
  }

  // Used by product cards, the detail modal, and the calculator.
  function addProductVariantToShopifyCart(variantId, quantity) {
    var qty = parseInt(quantity, 10) || 1;
    var numericId = parseInt(variantId, 10);

    // Demo or manual block items are not real Shopify variants.
    if (!numericId || String(variantId).indexOf("block-") !== -1 || String(variantId).indexOf("demo-") !== -1) {
      console.warn('DECKO: this item is not linked to a real Shopify variant, so it cannot be added to the cart.');
      openCartDrawer();
      refreshCart();
      return;
    }

    openCartDrawer();

    fetch(deckoShopRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: numericId, quantity: qty }] })
    })
      .then(function (r) {
        if (!r.ok) { return r.json().then(function (e) { throw e; }); }
        return r.json();
      })
      .then(function () { return refreshCart(); })
      .then(function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function (err) {
        console.error('DECKO add to cart failed:', err);
        var itemsContainer = document.getElementById("decko-cart-items-container");
        if (itemsContainer) {
          itemsContainer.innerHTML = '<p style="padding:16px;color:#c23b2b;font-size:13px;">'
            + 'Sorry, that item could not be added (it may be out of stock). Please try again.</p>';
        }
      });
  }

  // Kept for older inline calls. Adds one unit of the given product.
  window.DECKO_BUY_IMMEDIATE = function (productId) {
    var item = products.find(function (p) { return String(p.id) === String(productId); });
    if (item) addProductVariantToShopifyCart(item.id, 1);
  };

})();
